import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-flexbox-grid';
import { map, take, prop, propOr, filter } from 'ramda';

import { formatDate } from 'lib/dateDisplay';
import { createSummaryTile } from '../containers/SummaryLoaderContainer';
import TileRow from './TileRow';

import { path } from 'routes/Documents/routes/Rehabilitation';
import { sorter } from '../../../routes/Documents/routes/Rehabilitation/components/historyMapper';
import normalize from 'lib/normalize';

import icon from '../assets/rehabilitation.svg';

const formatTitleDate = d =>
  d.start
    ? d.end && d.hasEnded === 'yes'
      ? `${formatDate(d.start)} - ${formatDate(d.end)}`
      : formatDate(d.start)
    : null;

const opt = o => (o ? `rehabilitation.opts.${o}` : null);

const predicate = d => d.start && d.category;

const View = ({ data, localeMessage }) => (
  <Grid fluid>
    {map(d => (
      <TileRow key={d.documentId} title={formatTitleDate(d)}>
        <p className="bold">
          {prop('category', d) && !propOr(null, prop('category', d), d) && `${localeMessage(opt(prop('category', d)))}`}
          {prop('category', d) &&
            prop('category', d) !== 'other' &&
            propOr(null, prop('category', d), d) &&
            `${localeMessage(opt(prop('category', d)))}: ${localeMessage(opt(propOr(null, prop('category', d), d)))}`}
          {prop('category', d) &&
            prop('category', d) === 'other' &&
            propOr(null, prop('category', d), d) &&
            `${localeMessage(opt(prop('category', d)))}`}
        </p>
      </TileRow>
    ))(take(3, sorter(normalize(filter(predicate, data)))))}
  </Grid>
);

View.propTypes = {
  localeMessage: PropTypes.func.isRequired,
  data: PropTypes.array,
};

export default createSummaryTile(View, {
  module: 'rehabilitation',
  localeId: 'rehabilitation.title',
  routeTo: path,
  icon,
});
